import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Grid,
  Image,
  InputGroup,
  InputRightElement,
  Modal,
  ModalContent,
  ModalOverlay,
  Switch,
  Text,
  Textarea,
  useDisclosure,
  Checkbox,
  NumberInput,
  NumberInputField,
} from "@chakra-ui/react";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import iconClose from "../../assets/images/projectManagement/x-circle.svg";
import iconFile from "../../assets/images/projectManagement/file-text.svg";
import iconTrash from "../../assets/images/projectManagement/trash-2.svg";
import iconPlus from "../../assets/images/projectManagement/plus.svg";
import { useForm, Controller } from "react-hook-form";
import { InputControl, SelectControl } from "../form/formControls";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormBonus } from "../form/formBonus";
import { FormInputImage } from "../form/formImage";
import { useCategories } from "../../categorys/formAndPopup/popupProjectManagementAdd";
import { projectManagerCall } from "../../api/projectManager";
import { FormFileBonus } from "../form/formFileBonus";
import { projectDocumentCall } from "../../api/projectDocument";
import DeleteDialog from "../dialog/delete";
import { projectImageCall } from "../../api/projectImage";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import DatePicker from "react-datepicker";
import { TypeAgentProject } from "../../utils/contants";
import { useSelector } from "react-redux";
import { employeeCall } from "../../api/employee";

// CKEditor 5
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  ClassicEditor,
  Essentials,
  Paragraph,
  Heading,
  Bold,
  Italic,
  Underline,
  Link,
  List,
  BlockQuote,
  AutoLink,
  LinkUI,
} from "ckeditor5";

// UI + theme
import "ckeditor5/ckeditor5.css";

// Ngôn ngữ tiếng Việt cho UI
import viTranslations from "ckeditor5/translations/vi.js";

import { normalizeDescription } from "../../utils/utils";
import SearchableSelectMulti from "../selectForm/mutiSelect";
import trashIcon from "../../assets/images/projectManagement/trash-2.svg";
import { designBackgroundApi } from "../../api/designBackground";

const REACT_APP_ROUTE_RATE =
  process.env.REACT_APP_ROUTE_RATE ||
  "MSH_RATE_PRODUCT_AND_APARTMENT_MANAGEMENT";

const schema = Yup.object().shape({
  name: Yup.string().required("Vui lòng nhập tên dự án"),
  address: Yup.string().required("Vui lòng nhập địa chỉ"),
  // booking_price: Yup.number()
  //   .nullable()
  //   .transform((value, originalValue) => {
  //     if (typeof originalValue === "string") {
  //       return originalValue.trim() === "" ? null : Number(originalValue);
  //     }
  //     return originalValue === null ? null : Number(originalValue);
  //   })
  //   .optional(),
  // locking_price: Yup.number()
  //   .nullable()
  //   .transform((value, originalValue) => {
  //     if (typeof originalValue === "string") {
  //       return originalValue.trim() === "" ? null : Number(originalValue);
  //     }
  //     return originalValue === null ? null : Number(originalValue);
  //   })
  //   .optional(),
});

const PopupProjectManagementAdd = ({
  isOpen,
  onClose,
  defaultValues,
  onSubmit,
  isEdit,
  refetch,
}) => {
  const {
    isOpen: isOpenDelete,
    onOpen: onOpenDelete,
    onClose: onCloseDelete,
  } = useDisclosure();

  const {
    isOpen: isOpenDeleteImage,
    onOpen: onOpenDeleteImage,
    onClose: onCloseDeleteImage,
  } = useDisclosure();

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValues || {},
  });

  const [shouldFetch, setShouldFetch] = useState(false);
  const [checkedSwitch, setCheckedSwitch] = useState(
    defaultValues?.is_allow_ttkq || false,
  );
  const user = useSelector((state) => state.auth.login?.currentUser);
  const [getRoleUser, setGetRoleUser] = useState(false);

  const fetchDataUser = async (id) => {
    try {
      const res = await employeeCall.roleUser(id);
      if (res?.group_role_code) {
        const hasRole = res?.group_role_code
          ?.split(",")
          .includes(REACT_APP_ROUTE_RATE);
        setGetRoleUser(hasRole);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchDataUser(user?.user?._id);
  }, [user?.user?._id]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetch(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  const { constantData } = useCategories(shouldFetch);

  const formatEntriesForSelect = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({
      value: key,
      label: value,
    }));

  const investorData = useMemo(
    () => formatEntriesForSelect(constantData?.investor),
    [constantData?.investor],
  );

  const cityData = useMemo(
    () => formatEntriesForSelect(constantData?.city),
    [constantData?.city],
  );

  const projectTypeData = useMemo(
    () => formatEntriesForSelect(constantData?.projectType),
    [constantData?.projectType],
  );

  const employeeData = useMemo(() => {
    if (!constantData?.employee) return [];

    return Object.entries(constantData.employee).map(
      ([id, { fullName, code }]) => ({
        value: id,
        label: `${fullName} (${code})`,
      }),
    );
  }, [constantData?.employee]);

  const [focusedIndex, setFocusedIndex] = useState(null);
  const [focusStates, setFocusStates] = useState({});
  const [errorData, setErrorData] = useState(false);
  const [errorDataFile, setErrorDataFile] = useState(false);
  const [errorDataFileItem, setErrorDataFileItem] = useState({});
  const [errorDataImage, setErrorDataImage] = useState(false);
  const [file, setFile] = useState(null);

  //danh sách nhân viên quản lý và ảnh
  const [employeeProject, setEmployeeProject] = useState([
    {
      id: Date.now(),
      managerId: "",
      commission: "",
      participationStartDate: "",
      participationEndDate: "",
    },
  ]);
  const [errorEmployeeProject, setErrorEmployeeProject] = useState(false);
  const [errorEmployeeProjectItem, setErrorEmployeeProjectItem] = useState({});

  const [fileProject, setFileProject] = useState([]);
  const [imageOther, setImageOther] = useState([]);
  const [imageProject, setImageProject] = useState(null);
  const [imageHonor, setImageHonor] = useState(null);
  const [nameImageProject, setnameImageProject] = useState(null);
  const [nameImageHonor, setnameImageHonor] = useState(null);

  const [deteleFileId, setDeteleFileId] = useState(null);
  const [nameDelete, setNameDelete] = useState("");

  const [deteleImageOtherId, setDeteleImageOtherId] = useState(null);
  const [nameImageDelete, setNameImageDelete] = useState("");
  const [dateReceived, setDateReceived] = useState(null);

  useEffect(() => {
    if (!isOpen) return;
    setErrorDataFileItem({});
    setErrorData(false);

    setErrorEmployeeProjectItem({});
    setErrorEmployeeProject(false);

    reset({
      ...defaultValues,
    });
    if (defaultValues?.dataProjectManagers) {
      setEmployeeProject(defaultValues?.dataProjectManagers);
    } else {
      setEmployeeProject([
        {
          id: Date.now(),
          managerId: "",
          participationStartDate: "",
          participationEndDate: "",
        },
      ]);
    }

    if (defaultValues?.fileProject) {
      const simplifiedFiles = defaultValues?.fileProject.map(
        ({ id, path, name, typeFile }) => {
          const normalizedPath = path?.replace(/\\/g, "/");

          // Lấy phần cuối sau dấu `/`
          const fileFullName = normalizedPath?.split("/").pop();

          // Sau đó bỏ phần timestamp đằng trước (trước dấu `-`)
          const fileName = fileFullName?.substring(
            fileFullName?.indexOf("-") + 1,
          );

          return {
            id,
            name: name || fileName,
            nameFileMain: name || fileName,
            path,
            nameFile: name,
            status: false,
            typeFile: typeFile || false,
            typeFileMain: typeFile || false,
            linkFile: path || "",
          };
        },
      );

      setFileProject(simplifiedFiles);
    } else {
      setFileProject([]);
    }

    if (defaultValues?.imageOther) {
      const simplifiedFiles = defaultValues?.imageOther.map(
        ({ id, path, name }) => {
          const normalizedPath = path.replace(/\\/g, "/");

          // Lấy phần cuối sau dấu `/`
          const fileFullName = normalizedPath.split("/").pop();

          // Sau đó bỏ phần timestamp đằng trước (trước dấu `-`)
          const fileName = fileFullName.substring(
            fileFullName.indexOf("-") + 1,
          );

          return {
            id,
            name: fileName || name,
            path,
            nameFile: name,
            status: false,
          };
        },
      );

      setImageOther(simplifiedFiles);
    } else {
      setImageOther([]);
    }

    if (defaultValues?.imageProject) {
      if (
        defaultValues?.imageProject?.path &&
        defaultValues?.imageProject?.type === "AVATAR"
      ) {
        const filePath = defaultValues?.imageProject.path.split("\\").pop();
        const fileNameArr = filePath.split("/");
        const fileName = fileNameArr[fileNameArr.length - 1];
        setnameImageProject(fileName);
        setImageProject(defaultValues?.imageProject);
      }
    } else {
      setnameImageProject(null);
    }

    if (defaultValues?.imageHonor) {
      if (
        defaultValues?.imageHonor?.path &&
        defaultValues?.imageHonor?.type === "HONOR"
      ) {
        const filePath = defaultValues?.imageHonor.path.split("\\").pop();
        const fileNameArr = filePath.split("/");
        const fileName = fileNameArr[fileNameArr.length - 1];
        setnameImageHonor(fileName);
        setImageHonor(defaultValues?.imageHonor);
      }
    } else {
      setnameImageHonor(null);
    }

    if (defaultValues?.receivedMonth && defaultValues?.receivedYear) {
      const year = defaultValues.receivedYear;
      const month = defaultValues.receivedMonth - 1;

      defaultValues.timeReceived = new Date(year, month);
      setDateReceived(defaultValues.timeReceived);
      delete defaultValues.receivedMonth;
      delete defaultValues.receivedYear;
    }
  }, [isOpen, defaultValues]);

  // // Booking Price
  // const [bookingPriceValue, setBookingPriceValue] = useState("");
  // const onChangeBookingPrice = useCallback((event) => {
  //   const { value } = event.target;
  //   const numericValue = value.replace(/[^0-9]/g, "");
  //   setBookingPriceValue(formatPriceUS(numericValue));
  //   // setValue("booking_price", Number(numericValue), { shouldValidate: true });
  // }, []);

  // // Locking Price
  // const [lockingPriceValue, setLockingPriceValue] = useState("");
  // const onChangelockingPrice = useCallback((event) => {
  //   const { value } = event.target;
  //   const numericValue = value.replace(/[^0-9]/g, "");
  //   setLockingPriceValue(formatPriceUS(numericValue));
  //   setValue("locking_price", Number(numericValue), { shouldValidate: true });
  // }, []);

  //Xử lý quản lý nhân viên dự án
  const addEmployee = () => {
    setErrorDataFile(false);
    setErrorEmployeeProject(false);
    setEmployeeProject([
      ...employeeProject,
      {
        id: Date.now(),
        managerId: "",
        commission: "",
        participationStartDate: "",
        participationEndDate: "",
      },
    ]);
  };

  const deleteEmployee = async (id) => {
    setErrorDataFile(false);
    setErrorEmployeeProject(false);
    if (defaultValues?.dataProjectManagers) {
      const exists = defaultValues?.dataProjectManagers.some(
        (employee) => employee.id === id,
      );

      if (exists) {
        await projectManagerCall.delete(id);
      }
    }
    setEmployeeProject(employeeProject.filter((emp) => emp.id !== id));
  };

  const handleChange = (id, field, value) => {
    setErrorDataFile(false);
    setErrorEmployeeProject(false);
    setEmployeeProject(
      employeeProject.map((emp) =>
        emp.id === id ? { ...emp, [field]: value } : emp,
      ),
    );
  };
  //Kết thúc xử lý quản lý nhân viên dự án

  //Xử lý image other
  const addImageOther = () => {
    setErrorDataImage(false);
    setImageOther([
      ...imageOther,
      { id: Date.now(), name: "", nameFile: "", status: true },
    ]);
  };

  const deleteImageOther = (id) => {
    setErrorDataImage(false);

    const exists = defaultValues?.imageOther
      ? defaultValues?.imageOther.some((employee) => employee.id === id)
      : null;
    if (exists) {
      setDeteleImageOtherId(id);
      setNameImageDelete(
        imageOther.find((emp) => emp.id === id)?.nameFile || "",
      );
      onOpenDeleteImage();
    } else {
      setImageOther(imageOther.filter((emp) => emp.id !== id));
    }
  };

  const onDeleteImageOther = async (id) => {
    const exists = defaultValues?.imageOther.some(
      (employee) => employee.id === id,
    );

    try {
      if (exists) {
        await projectImageCall.delete(id);
        onCloseDeleteImage();
        refetch();
      }
      setImageOther(imageOther.filter((emp) => emp.id !== id));
    } catch (error) {
      console.log({ error });
    }
  };

  const handleChangeImageOther = (id, field, value) => {
    setErrorDataImage(false);
    setImageOther(
      imageOther.map((emp) =>
        emp.id === id ? { ...emp, [field]: value, status: true } : emp,
      ),
    );
  };
  //Kết thúc xử lý image other

  //Xử lý file
  const addFileProject = () => {
    setErrorDataFile(false);
    setFileProject([
      ...fileProject,
      {
        id: Date.now(),
        name: "",
        nameFile: "",
        status: true,
        typeFile: false,
        linkFile: "",
      },
    ]);
  };

  const deleteFileProject = (id) => {
    setErrorDataFile(false);
    const exists = defaultValues?.fileProject
      ? defaultValues?.fileProject?.some((employee) => employee.id === id)
      : false;
    if (exists) {
      setDeteleFileId(id);
      setNameDelete(fileProject.find((emp) => emp.id === id)?.nameFile || "");
      onOpenDelete();
    } else {
      setFileProject(fileProject.filter((emp) => emp.id !== id));
    }
  };

  const onDeleteDataFile = async (id) => {
    const exists = defaultValues?.fileProject.some(
      (employee) => employee.id === id,
    );

    try {
      if (exists) {
        await projectDocumentCall.delete(id);
        onCloseDelete();
        refetch();
      }
      setFileProject(fileProject.filter((emp) => emp.id !== id));
    } catch (error) {
      console.log({ error });
    }
  };

  const handleChangeFile = (id, field, value) => {
    setErrorDataFile(false);

    if (field === "linkFile") {
      const hasAnyFieldEmpty = fileProject?.some(
        (file) => file.linkFile === value && id !== file.id,
      );

      if (hasAnyFieldEmpty) {
        setErrorDataFile(true);
        setErrorDataFileItem({
          id: id,
          status: true,
        });
      }
      if (!hasAnyFieldEmpty) {
        setErrorDataFile(false);
        setErrorDataFileItem({
          id: id,
          status: false,
        });
      }
    }

    setFileProject(
      fileProject.map((emp) =>
        emp.id === id ? { ...emp, [field]: value, status: true } : emp,
      ),
    );
  };

  const handleTypeFile = (id, field, value) => {
    setErrorDataFile(false);
    let dataFile = {};
    // if (field === "typeFile") { console.log("dagiang dai")
    //   dataFile.path = "";
    //   dataFile.name = "";
    //   dataFile.nameFile = "";
    //   dataFile.linkFile = "";
    // }
    setFileProject(
      fileProject.map((emp) =>
        emp.id === id
          ? { ...emp, [field]: value, status: true, ...dataFile }
          : emp,
      ),
    );
  };
  //Kết thúc xử lý file

  const handleFocus = (field, index) => {
    console.log(index);
    if (index !== null) {
      setFocusedIndex(index);
    } else {
      setFocusStates((prev) => ({ ...prev, [field]: true }));
    }
  };

  const handleBlur = (field, index) => {
    // setZIndex("");
    if (index !== null) {
      setFocusedIndex(index);
    } else {
      setFocusedIndex(null);
    }
    setFocusStates((prev) => ({ ...prev, [field]: false }));
  };

  const onchangeTypeProject = (option) => {
    setValue("projectTypeId", option);
  };

  const onchangeCity = (option) => {
    setValue("cityId", option);
  };

  const onchangeInvestor = (option) => {
    setValue("investorId", option);
  };

  const onchangeAgent = (option) => {
    setValue("agent", option);
  };

  const openFile = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const dataUrl = e.target.result;
        setFile(dataUrl);
        setValue(type, file);
      };
      reader.readAsDataURL(file);
    }
  };

  const submitHandler = (data) => {
    const allFieldsEmpty = employeeProject?.every(
      (employee) =>
        !employee.managerId &&
        !employee.commission &&
        !employee.participationEndDate &&
        !employee.participationStartDate,
    );

    const hasAnyFieldEmpty = employeeProject?.some(
      (employee) =>
        !employee.managerId ||
        !employee.commission ||
        !employee.participationEndDate ||
        !employee.participationStartDate,
    );

    const hasAnyFieldFileEmpty = fileProject?.every((file) => {
      const hasUpload =
        (file?.nameFile || file?.file?.name) && (file.path || file.file);
      // console.log(hasUpload)
      const hasLink = file?.nameFile && file.linkFile?.trim();
      if (file?.typeFile) {
        return hasLink;
      } else {
        return hasUpload;
      }
    });

    const hasAnyFieldImageEmpty = imageOther?.every(
      (file) => file.nameFile && (file.path || file.file),
    );

    // if (!data?.booking_price) delete data.booking_price;
    // if (!data?.locking_price) delete data.locking_price;

    if (errorDataFileItem?.status) {
      setErrorDataFile(true);
    } else if (hasAnyFieldEmpty && !allFieldsEmpty) {
      setErrorData(true);
    } else if (fileProject?.length > 0 && !hasAnyFieldFileEmpty) {
      setErrorDataFile(true);
      setErrorData(false);
    } else if (imageOther?.length > 0 && !hasAnyFieldImageEmpty) {
      setErrorDataImage(true);
      setErrorData(false);
      setErrorDataFile(false);
    } else {
      setErrorData(false);
      setErrorDataFile(false);
      setErrorDataImage(false);
      if (!allFieldsEmpty) data.employeeProject = employeeProject;
      if (!imageProject) data.imageProject = imageProject;
      if (!imageHonor) data.imageHonor = imageHonor;
      if (fileProject) data.fileProject = fileProject;
      if (imageOther) data.imageOther = imageOther;

      if (data?.timeReceived) {
        const month = data?.timeReceived?.getMonth() + 1; // Tháng bắt đầu từ 0
        const year = data?.timeReceived?.getFullYear();

        delete data.timeReceived;
        data.receivedMonth = month;
        data.receivedYear = year;
      }

      // console.log({ data });
      onSubmit(data);
    }
  };

  const handleDateChange = (e, inputName) => {
    setValue(inputName, e, { shouldValidate: true });
  };

  const BANNER_TYPES = ["BOOKING", "LOCKING", "HDMB", "TTKQ"];

  // config banner
  // ===== BANNER CONFIG (multi-block) =====
  // Danh sách block hiển thị trên UI:
  // [{ id, designBackground: {value,label} | null, banners: { [type]: {checked, order} } }]
  const [bannerBlocks, setBannerBlocks] = useState([]);

  // Dữ liệu nhóm hiện có từ server (listGroupBanner)
  const [serverBannerGroups, setServerBannerGroups] = useState([]);

  const designBackgroundOptions = useMemo(
    () => formatEntriesForSelect(constantData?.designBanner),
    [constantData?.designBanner],
  );

  const designBackgroundOptionMap = useMemo(
    () => new Map((designBackgroundOptions || []).map((o) => [o.value, o])),
    [designBackgroundOptions],
  );

  // Khởi tạo một block rỗng
  const createEmptyBlock = () => ({
    id: `tmp-${Date.now()}`,
    designBackground: null,
    banners: BANNER_TYPES.reduce((acc, t) => {
      acc[t] = { checked: false, order: 1 };
      return acc;
    }, {}),
  });

  const getDesignBackgrounds = async (projectId) => {
    const data = await designBackgroundApi.listTypebyProjectAndBanner({
      projectId,
    });
    if (data?.items) setServerBannerGroups(data.items);
  };

  useEffect(() => {
    if (defaultValues?.id) getDesignBackgrounds(defaultValues?.id);
  }, [defaultValues?.id]);

  useEffect(() => {
    if (!serverBannerGroups) return;
    const blocks = serverBannerGroups.map((it) => {
      const option =
        designBackgroundOptionMap.get(it.designBackgroundId) || null;
      const banners = BANNER_TYPES.reduce((acc, t) => {
        // mặc định unchecked
        acc[t] = { checked: false, order: 1 };
        return acc;
      }, {});
      // điền type + order từ server (field: it.banners = [{type, order}])
      (it.banners || []).forEach(({ type, order }) => {
        if (BANNER_TYPES.includes(type)) {
          banners[type] = {
            checked: true,
            order: typeof order === "number" ? order : 1,
          };
        }
      });
      return {
        id: it.designBackgroundId,
        designBackground: option?.value,
        banners,
      };
    });
    setBannerBlocks(blocks);
  }, [serverBannerGroups, designBackgroundOptionMap]);

  // Thêm block mới
  const addBanner = () => {
    setBannerBlocks((prev) => [...prev, createEmptyBlock()]);
  };

  // Xóa block (chỉ UI, lưu mới gọi API)
  const removeBanner = (id) => {
    setBannerBlocks((prev) => prev.filter((b) => b.id !== id));
  };

  // Chọn banner (designBackground) cho block
  const changeBlockDesignBackground = (id, option) => {
    setBannerBlocks((prev) =>
      prev.map((b) => (b.id === id ? { ...b, designBackground: option } : b)),
    );
  };

  // Tick/untick type trong block
  const toggleBannerType = (id, type, checked) => {
    setBannerBlocks((prev) =>
      prev.map((b) =>
        b.id === id
          ? {
              ...b,
              banners: {
                ...b.banners,
                [type]: { ...b.banners[type], checked },
              },
            }
          : b,
      ),
    );
  };

  // Đổi order của type trong block
  const changeBannerOrder = (id, type, order) => {
    const safe = Number(order);
    setBannerBlocks((prev) =>
      prev.map((b) =>
        b.id === id
          ? {
              ...b,
              banners: {
                ...b.banners,
                [type]: { ...b.banners[type], order: isNaN(safe) ? 1 : safe },
              },
            }
          : b,
      ),
    );
  };

  const saveBanners = async () => {
    const projectId = defaultValues?.id;
    if (!projectId) return;

    // Chuẩn bị payload cho từng block
    const payloads = bannerBlocks.map((block) => {
      const designBackgroundId = block.designBackground;
      const list = BANNER_TYPES.filter((t) => block.banners[t].checked).map(
        (t) => ({
          designBackgroundId,
          projectId,
          type: t,
          order: Number(block.banners[t].order) || 1,
        }),
      );
      return { designBackgroundId, projectId, list };
    });

    console.log({ payloads });

    // Validate: block có ít nhất 1 type mà chưa chọn banner → bỏ qua / hoặc cảnh báo
    const validPayloads = payloads.filter((p) => p.designBackgroundId);
    console.log({ validPayloads });
    try {
      const body = {
        projectId,
        list: [],
      };
      for (const item of validPayloads) {
        body.list.push(...item.list);
        // await designBackgroundApi.bulkAction(body);
        // bulkAction sẽ: deleteMany({ designBackgroundId, projectId }) + upsert list
      }
      console.log({ body });
      await designBackgroundApi.bulkAction(body);
      // Reload list sau khi lưu
      await getDesignBackgrounds(projectId);
    } catch (e) {
      // toast lỗi đã có trong api layer
      console.error(e);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      trapFocus={false}
      blockScrollOnMount={false}
    >
      <ModalOverlay />
      <ModalContent
        borderRadius={"16px"}
        maxW={"1210px"}
        maxH={"88vh"}
        overflow="auto"
      >
        <form
          style={{
            maxHeight: "88vh",
          }}
          onSubmit={handleSubmit(submitHandler)}
        >
          <Flex
            borderBottom={"1px solid var(--color-boder)"}
            alignItems={"center"}
            justifyContent={"space-between"}
            p={"24px 20px 24px 24px"}
          >
            <Text fontSize={"18px"} fontWeight={600} lineHeight={"normal"}>
              Tạo dự án
            </Text>
            <Image src={iconClose} onClick={onClose} cursor={"pointer"} />
          </Flex>
          <Box p={"0px 40px 24px 40px"} h={"auto"}>
            <Flex h={"auto"}>
              <Flex
                flex={1}
                mt={"24px"}
                flexDirection={"column"}
                gap={{ base: "24px" }}
              >
                <Flex flexDirection={"column"} gap={"16px"}>
                  <Text fontSize={"16px"} fontWeight={600}>
                    Thông tin dự án
                  </Text>
                  <Flex gap={"8px"} flexDirection={"column"}>
                    <InputControl
                      label="Tên dự án"
                      placeholder="Nhập tên dự án"
                      errors={errors.name}
                      register={register("name")}
                      onFocus={() => handleFocus("name")}
                      onBlur={() => handleBlur("name")}
                      state={focusStates["name"]}
                      mwidth={"100%"}
                      isRequired={true}
                    />
                    <FormControl>
                      <FormLabel
                        mb="6px"
                        fontSize="12px"
                        fontWeight={400}
                        color={
                          focusStates["description"]
                            ? "var(--color-option-employee-hover)"
                            : "var(--color-label-employee)"
                        }
                      >
                        Mô tả dự án
                      </FormLabel>

                      <Controller
                        name="description"
                        control={control}
                        defaultValue={normalizeDescription(
                          defaultValues?.description || "",
                        )}
                        render={({ field: { onChange, onBlur, value } }) => (
                          <Box
                            border="1px solid var(--color-boder)"
                            borderRadius="8px"
                            _focusWithin={{
                              boxShadow: "none",
                              border: "1px solid var(--color-boder)",
                            }}
                            // onFocus={() => handleFocus("description")}
                            // onBlur={() => {
                            //   handleBlur("description");
                            //   onBlur();
                            // }}
                          >
                            <CKEditor
                              editor={ClassicEditor}
                              data={value || ""}
                              config={{
                                licenseKey: "GPL", // dùng bản free
                                plugins: [
                                  Essentials,
                                  Paragraph,
                                  Heading,
                                  Bold,
                                  Italic,
                                  Underline,
                                  Link,
                                  LinkUI,
                                  AutoLink, // <— bật tự tạo link
                                  List,
                                  BlockQuote,
                                ],
                                toolbar: [
                                  "undo",
                                  "redo",
                                  "|",
                                  "heading",
                                  "|",
                                  "bold",
                                  "italic",
                                  "underline",
                                  "|",
                                  "link",
                                  "|",
                                  "bulletedList",
                                  "numberedList",
                                  "|",
                                  "blockQuote",
                                ],
                                translations: [viTranslations],
                                language: { ui: "vi", content: "vi" },
                                link: {
                                  addTargetToExternalLinks: true,
                                  defaultProtocol: "https://",
                                },
                                placeholder: "Mô tả dự án...",
                              }}
                              onChange={(_, editor) =>
                                onChange(editor.getData())
                              }
                              // onBlur={(_, editor) => {
                              //   handleBlur("description");
                              //   onBlur();
                              // }}
                            />
                          </Box>
                        )}
                      />
                      {errors.description && (
                        <Text color="red.500" fontSize="sm" mt="2">
                          {errors.description.message}
                        </Text>
                      )}
                    </FormControl>
                  </Flex>
                  <Flex
                    justifyContent={"space-between"}
                    alignItems={"flex-start"}
                    gap={"27px"}
                  >
                    <SelectControl
                      label="Loại hình dự án"
                      selectedMain={watch("projectTypeId")}
                      dataOption={projectTypeData}
                      placeholder="Chọn loại hình dự án"
                      errorMessage={errors.projectTypeId}
                      onChange={onchangeTypeProject}
                      onFocus={() => handleFocus("projectTypeId")}
                      onBlur={() => handleBlur("projectTypeId")}
                      state={focusStates["projectTypeId"]}
                      registerProps={register("projectTypeId")}
                      isSearchable={true}
                    />
                    <SelectControl
                      label="Thành phố"
                      selectedMain={watch("cityId")}
                      dataOption={cityData}
                      placeholder="Chọn loại thành phố"
                      errorMessage={errors.cityId}
                      onChange={onchangeCity}
                      onFocus={() => handleFocus("cityId")}
                      onBlur={() => handleBlur("cityId")}
                      state={focusStates["cityId"]}
                      registerProps={register("cityId")}
                      isSearchable={true}
                    />
                  </Flex>
                  <Flex
                    justifyContent={"space-between"}
                    alignItems={"flex-start"}
                    gap={"27px"}
                  >
                    <InputControl
                      label="Địa chỉ"
                      placeholder="Nhâp địa chỉ dự án"
                      errors={errors.address}
                      register={register("address")}
                      onFocus={() => handleFocus("address")}
                      onBlur={() => handleBlur("address")}
                      state={focusStates["address"]}
                      mwidth={"100%"}
                      isRequired={true}
                    />
                  </Flex>
                  <Flex alignItems={"center"} gap={{ base: "27px" }}>
                    {/* <Box flex={1} position={"relative"}>
                      <FormTimeKeeping
                        title={"Tài liệu dự án"}
                        place={"Tải tài liệu lên"}
                        isIconPlace={true}
                        isIconTime={false}
                        length={"100%"}
                        register={register("fileProject")}
                        errors={errors.fileProject}
                        handleClick={openFile}
                        icon={iconFile}
                        inputTypeFile={true}
                        name={defaultValues?.nameProject || ""}
                      />
                    </Box> */}
                    <SelectControl
                      label="Chủ đầu tư"
                      selectedMain={watch("investorId")}
                      dataOption={investorData}
                      placeholder="Chọn chủ đầu tư"
                      errorMessage={errors.investorId}
                      onChange={onchangeInvestor}
                      onFocus={() => handleFocus("investorId")}
                      onBlur={() => handleBlur("investorId")}
                      state={focusStates["investorId"]}
                      registerProps={register("investorId")}
                      isSearchable={true}
                    />
                    <Flex mt={"16px"}>
                      <Box>
                        <Text
                          lineHeight={"15px"}
                          m="0"
                          fontSize={{ base: "12px" }}
                          mb={"6px"}
                          fontWeight={400}
                          color={"var(--color-label-employee)"}
                        >
                          Cho phép lên TTKQ/VBTT/HĐTHNV
                        </Text>
                        <Switch
                          {...register("is_allow_ttkq")}
                          checked={checkedSwitch}
                          onChange={(e) => setCheckedSwitch(e.target.checked)}
                        />
                      </Box>
                    </Flex>
                  </Flex>

                  <Flex
                    justifyContent={"space-between"}
                    alignItems={"flex-start"}
                    gap={"27px"}
                  >
                    <SelectControl
                      label="Loại đại lý"
                      selectedMain={watch("agent")}
                      dataOption={TypeAgentProject}
                      placeholder="Chọn loại đại lý"
                      errorMessage={errors.agent}
                      onChange={onchangeAgent}
                      onFocus={() => handleFocus("agent")}
                      onBlur={() => handleBlur("agent")}
                      state={focusStates["agent"]}
                      registerProps={register("agent")}
                      isSearchable={false}
                    />
                    <FormControl flex={1} zIndex={3}>
                      <FormLabel
                        mb={"6px"}
                        fontSize={{ base: "12px" }}
                        fontWeight={400}
                        color={
                          focusStates["startTime"]
                            ? "var(--color-option-employee-hover)"
                            : "var(--color-label-employee)"
                        }
                        display={"flex"}
                        gap={"4px"}
                      >
                        Thời gian tiếp nhận
                      </FormLabel>
                      <InputGroup>
                        <DatePicker
                          width="100%"
                          selected={watch("timeReceived") || dateReceived}
                          onChange={(date) =>
                            handleDateChange(date, "timeReceived")
                          }
                          dateFormat="MM/yyyy"
                          showMonthYearPicker
                          locale="vi"
                          placeholderText="mm/yyyy"
                          className="custom-datepicker datePickerStyle"
                          onFocus={() =>
                            handleFocus("timeReceived", "timeReceived")
                          }
                          onBlur={() => handleBlur("timeReceived")}
                        />
                        <InputRightElement pointerEvents="none" h={"44px"}>
                          <Image src={calendarIcon} />
                        </InputRightElement>
                      </InputGroup>

                      {errors.timeReceived && (
                        <Text fontSize={{ base: "12px" }} color={"red"}>
                          {errors.timeReceived.message}
                        </Text>
                      )}
                    </FormControl>
                  </Flex>

                  {getRoleUser && (
                    <>
                      <Flex
                        justifyContent={"space-between"}
                        alignItems={"flex-start"}
                        gap={"27px"}
                      >
                        <InputControl
                          type="number"
                          // step="any"
                          label="% Hoa hồng nhận từ CĐT (X)"
                          placeholder="Nhập % phí dịch vụ nhận từ CĐT (X)"
                          errors={errors.commissionFromInvestor}
                          register={register("commissionFromInvestor")}
                          onFocus={() => handleFocus("commissionFromInvestor")}
                          onBlur={() => handleBlur("commissionFromInvestor")}
                          state={focusStates["commissionFromInvestor"]}
                          mwidth={"100%"}
                          onlyPositiveNumbers={true}
                          isRate={true}
                        />
                        <InputControl
                          type="number"
                          // step="any"
                          label="% Hoa hồng trả cho sale (Y)"
                          placeholder="Nhập % phí dịch vụ trả cho sale (Y)"
                          errors={errors.commissionToSales}
                          register={register("commissionToSales")}
                          onFocus={() => handleFocus("commissionToSales")}
                          onBlur={() => handleBlur("commissionToSales")}
                          state={focusStates["commissionToSales"]}
                          mwidth={"100%"}
                          onlyPositiveNumbers={true}
                          isRate={true}
                        />
                      </Flex>
                      <Flex
                        justifyContent={"space-between"}
                        alignItems={"flex-start"}
                        gap={"27px"}
                      >
                        <InputControl
                          type="number"
                          // step="any"
                          label="% Hoa hồng nhận từ đối tác ngoài CĐT (Z)"
                          placeholder="Nhập % phí dịch vụ nhận từ đối tác ngoài CĐT (Z)"
                          errors={errors.commissionFromPartner}
                          register={register("commissionFromPartner")}
                          onFocus={() => handleFocus("commissionFromPartner")}
                          onBlur={() => handleBlur("commissionFromPartner")}
                          state={focusStates["commissionFromPartner"]}
                          mwidth={"100%"}
                          onlyPositiveNumbers={true}
                          isRate={true}
                        />
                      </Flex>
                    </>
                  )}

                  {/* <Flex
                    justifyContent={"space-between"}
                    alignItems={"flex-start"}
                    gap={"27px"}
                  >
                    <InputControl
                      // type="number"
                      label="Số tiền booking"
                      placeholder="Ví dụ: 195000000000 "
                      errors={errors.booking_price}
                      onFocus={() => handleFocus("booking_price")}
                      onBlur={() => handleBlur("booking_price")}
                      onChange={onChangeBookingPrice}
                      value={bookingPriceValue}
                      state={focusStates["booking_price"]}
                      register={register("booking_price")}
                      mwidth={"100%"}
                    />
                  </Flex>

                  <Flex
                    justifyContent={"space-between"}
                    alignItems={"flex-start"}
                    gap={"27px"}
                  >
                    <InputControl
                      // type="number"
                      label="Số tiền đặt cọc"
                      placeholder="Ví dụ: 195000000000 "
                      errors={errors.locking_price}
                      onFocus={() => handleFocus("locking_price")}
                      onBlur={() => handleBlur("locking_price")}
                      onChange={onChangelockingPrice}
                      value={lockingPriceValue}
                      state={focusStates["locking_price"]}
                      register={register("locking_price")}
                      mwidth={"100%"}
                    />
                  </Flex> */}

                  <Flex flexDirection={"column"} gap={"16px"} mt={"12px"}>
                    <Flex
                      alignItems={"center"}
                      justifyContent={"space-between"}
                    >
                      <Text
                        fontSize={"16px"}
                        fontWeight={600}
                        lineHeight={"normal"}
                        color="var(--color-black)"
                      >
                        Tài liệu dự án
                      </Text>
                    </Flex>
                    <Flex alignItems={"center"} gap={{ base: "27px" }}>
                      <Flex
                        justifyContent={"space-between"}
                        alignItems={"flex-start"}
                        gap={"24px"}
                        w={"100%"}
                        flexDirection={"column"}
                      >
                        {fileProject.map((emp, index) => {
                          return (
                            <Box w={"100%"} key={emp.id}>
                              <FormFileBonus
                                inputTypeFile={true}
                                deleteData={() => deleteFileProject(emp.id)}
                                onChangeNameFile={(e) => {
                                  handleChangeFile(emp.id, "nameFile", e);
                                }}
                                onChangeFile={(e) => {
                                  handleChangeFile(emp.id, "file", e);
                                }}
                                onChangeLinkFile={(e) => {
                                  handleChangeFile(emp.id, "linkFile", e);
                                }}
                                onChangeTypeFile={(e) => {
                                  handleTypeFile(emp.id, "typeFile", e);
                                }}
                                id={emp.id}
                                name={emp?.file?.name || emp?.name}
                                nameFile={emp?.nameFile}
                                nameFileMain={emp?.nameFile}
                                nameLinkFile={emp?.linkFile}
                                file={emp?.file || emp?.path}
                                path={emp?.path}
                                mainTypeFile={emp?.typeFileMain}
                                typeFile={emp?.typeFile ? 2 : 1}
                                status={emp?.status}
                                fileSelect={true}
                                isRequired={true}
                                isError={errorDataFile}
                                isErrorItem={errorDataFileItem}
                              />
                            </Box>
                          );
                        })}
                        {/* {errorDataFile && (
                          <Text
                            w={"100%"}
                            color={"var(--text-red-employee)"}
                            fontSize={"12px"}
                          >
                            Vui lòng nhập đầy đủ thông tin tài liệu
                          </Text>
                        )} */}

                        <Flex
                          gap={"4px"}
                          alignItems={"end"}
                          p="8px 16px"
                          border={
                            "1px solid var(--color-option-employee-hover)"
                          }
                          borderRadius={"8px"}
                          w={"max-content"}
                          mr={"60px"}
                          cursor={"pointer"}
                          bg={"var(--color-main)"}
                          onClick={addFileProject}
                          _hover={{
                            filter: "brightness(90%)",
                          }}
                        >
                          <Image src={iconPlus} />
                          <Text
                            fontSize={"12px"}
                            lineHeight={"15px"}
                            color={"var(--color-option-employee-hover)"}
                            fontWeight={600}
                          >
                            Thêm File
                          </Text>
                        </Flex>
                      </Flex>
                    </Flex>
                  </Flex>
                </Flex>
                <Flex flexDirection={"column"} gap={"16px"}>
                  <Flex alignItems={"center"} justifyContent={"space-between"}>
                    <Text
                      fontSize={"16px"}
                      fontWeight={600}
                      lineHeight={"normal"}
                      color="var(--color-black)"
                    >
                      Nhân viên quản lý dự án
                    </Text>
                  </Flex>
                  <Flex
                    mt={"12px"}
                    flexDirection={"column"}
                    gap={"12px"}
                    alignItems={"flex-end"}
                  >
                    <Flex
                      justifyContent={"space-between"}
                      alignItems={"flex-start"}
                      gap={"12px"}
                      w={"100%"}
                      flexDirection={"column"}
                    >
                      {employeeProject.map((emp, index) => {
                        return (
                          <FormBonus
                            key={index}
                            zIndex={index}
                            isIconPlace={true}
                            isIconTime={false}
                            length={"100%"}
                            onChangeName={(e) => {
                              handleChange(emp.id, "managerId", e);
                            }}
                            onChangeBonus={(e) => {
                              handleChange(emp.id, "commission", e);
                            }}
                            onChangeStartDate={(e) => {
                              handleChange(emp.id, "participationStartDate", e);
                            }}
                            onChangeEndDate={(e) => {
                              handleChange(emp.id, "participationEndDate", e);
                            }}
                            deleteData={() => deleteEmployee(emp.id)}
                            icon={iconTrash}
                            nameMain={emp?.commission || null}
                            selectedMain={emp.managerId}
                            selectedStartDate={emp.participationStartDate}
                            selectedEndDate={emp.participationEndDate}
                            isAddDate={true}
                            filteredOptions={employeeData}
                            isFocused={focusedIndex === index}
                            onFocus={() => handleFocus("managerProject", index)}
                            onBlur={() => handleBlur("managerProject", index)}
                            isError={errorEmployeeProject}
                            isErrorItem={errorEmployeeProjectItem}
                          />
                        );
                      })}
                    </Flex>
                    {errorData && (
                      <Text
                        w={"100%"}
                        color={"var(--text-red-employee)"}
                        fontSize={"12px"}
                      >
                        Vui lòng nhập đầy đủ thông tin
                      </Text>
                    )}

                    <Flex
                      gap={"4px"}
                      alignItems={"end"}
                      p="8px 16px"
                      border={"1px solid var(--color-option-employee-hover)"}
                      borderRadius={"8px"}
                      w={"max-content"}
                      mr={"60px"}
                      cursor={"pointer"}
                      bg={"var(--color-main)"}
                      onClick={addEmployee}
                      _hover={{
                        filter: "brightness(90%)",
                      }}
                    >
                      <Image src={iconPlus} />
                      <Text
                        fontSize={"12px"}
                        lineHeight={"15px"}
                        color={"var(--color-option-employee-hover)"}
                        fontWeight={600}
                      >
                        Thêm NV tham gia
                      </Text>
                    </Flex>
                  </Flex>
                </Flex>
              </Flex>
              <Box w={"1px"} m="0 28px" h={"auto"} bg={"var(--Line)"}></Box>
              <Flex flex={1} mt={"24px"} flexDirection={"column"} gap={"16px"}>
                <Text fontSize={"16px"} fontWeight={600}>
                  Ảnh dự án
                </Text>
                <Grid templateColumns="1fr" rowGap={"16px"} columnGap={"27px"}>
                  <FormInputImage
                    label={"Hình đại diện"}
                    placeholder={"Chọn hình đại diện"}
                    data={imageProject}
                    onChangeImage={openFile}
                    type={"project"}
                    value={nameImageProject}
                  />
                </Grid>
                <Grid templateColumns="1fr" rowGap={"16px"} columnGap={"27px"}>
                  <FormInputImage
                    label={"Hình vinh danh"}
                    placeholder={"Chọn hình vinh danh"}
                    data={imageHonor}
                    onChangeImage={openFile}
                    type={"honor"}
                    value={nameImageHonor}
                  />
                </Grid>

                <Flex flexDirection={"column"} gap={"16px"} mt={"12px"}>
                  <Flex alignItems={"center"} justifyContent={"space-between"}>
                    <Text
                      fontSize={"16px"}
                      fontWeight={600}
                      lineHeight={"normal"}
                      color="var(--color-black)"
                    >
                      Ảnh khác
                    </Text>
                  </Flex>
                  <Flex alignItems={"center"} gap={{ base: "27px" }}>
                    <Flex
                      justifyContent={"space-between"}
                      alignItems={"flex-start"}
                      gap={"24px"}
                      w={"100%"}
                      flexDirection={"column"}
                    >
                      {imageOther.map((emp, index) => {
                        return (
                          <Box w={"100%"} key={emp.id}>
                            <FormFileBonus
                              inputTypeFile={true}
                              typeFile={"image"}
                              deleteData={() => deleteImageOther(emp.id)}
                              onChangeNameFile={(e) => {
                                handleChangeImageOther(emp.id, "nameFile", e);
                              }}
                              onChangeFile={(e) => {
                                handleChangeImageOther(emp.id, "file", e);
                              }}
                              onChangeTypeFile={(e) => {
                                // handleTypeFile(emp.id, "typeFile", e);
                              }}
                              name={emp?.file?.name || emp?.name}
                              nameFileMain={emp?.nameFile}
                              status={emp?.status}
                              isRequired={true}
                            />
                          </Box>
                        );
                      })}
                      {errorDataImage && (
                        <Text
                          w={"100%"}
                          color={"var(--text-red-employee)"}
                          fontSize={"12px"}
                        >
                          Vui lòng nhập đầy đủ tên ảnh và ảnh
                        </Text>
                      )}

                      <Flex
                        gap={"4px"}
                        alignItems={"end"}
                        p="8px 16px"
                        border={"1px solid var(--color-option-employee-hover)"}
                        borderRadius={"8px"}
                        w={"max-content"}
                        mr={"60px"}
                        cursor={"pointer"}
                        bg={"var(--color-main)"}
                        onClick={addImageOther}
                        _hover={{
                          filter: "brightness(90%)",
                        }}
                      >
                        <Image src={iconPlus} />
                        <Text
                          fontSize={"12px"}
                          lineHeight={"15px"}
                          color={"var(--color-option-employee-hover)"}
                          fontWeight={600}
                        >
                          Thêm ảnh
                        </Text>
                      </Flex>
                    </Flex>
                  </Flex>
                </Flex>

                {/* Banner */}
                <Flex flexDirection={"column"} gap={"16px"} mt={"12px"}>
                  <Flex alignItems={"center"} justifyContent={"space-between"}>
                    <Text
                      fontSize={"16px"}
                      fontWeight={600}
                      color="var(--color-black)"
                    >
                      Banner
                    </Text>
                    <Flex
                      gap={"4px"}
                      alignItems={"center"}
                      p="8px 16px"
                      border={"1px solid var(--color-option-employee-hover)"}
                      borderRadius={"8px"}
                      w={"max-content"}
                      cursor={"pointer"}
                      bg={"var(--color-main)"}
                      onClick={addBanner}
                      _hover={{ filter: "brightness(90%)" }}
                    >
                      <Image src={iconPlus} />
                      <Text
                        fontSize={"12px"}
                        lineHeight={"15px"}
                        color={"var(--color-option-employee-hover)"}
                        fontWeight={600}
                      >
                        Thêm banner
                      </Text>
                    </Flex>
                  </Flex>

                  <Flex direction={"column"} gap={6} w={"full"}>
                    {bannerBlocks.map((block) => (
                      <Box
                        key={block.id}
                        border="1px solid var(--color-boder)"
                        borderRadius="12px"
                        p="12px"
                      >
                        <Flex
                          gap={4}
                          alignItems={"center"}
                          justifyContent={"space-between"}
                        >
                          <SelectControl
                            label={"Chọn banner"}
                            selectedMain={block.designBackground}
                            dataOption={designBackgroundOptions}
                            placeholder="Chọn banner"
                            onChange={(opt) =>
                              changeBlockDesignBackground(block.id, opt)
                            }
                            isSearchable={true}
                          />
                          <Image
                            cursor={"pointer"}
                            src={trashIcon}
                            h={"22px"}
                            w={"22px"}
                            mr={"12px"}
                            minH={"22px"}
                            minW={"22px"}
                            onClick={() => removeBanner(block.id)}
                            _hover={{ filter: "var(--filter-red)" }}
                          />
                        </Flex>

                        {/* Checkboxes + order inputs */}
                        <Grid
                          templateColumns={{
                            base: "1fr",
                            md: "repeat(2, 1fr)",
                          }}
                          gap={4}
                          mt={4}
                        >
                          {BANNER_TYPES.map((t) => (
                            <Flex
                              key={t}
                              alignItems="center"
                              gap={3}
                              border="1px dashed var(--color-boder)"
                              borderRadius="8px"
                              p="10px"
                            >
                              <Checkbox
                                isChecked={block.banners[t].checked}
                                onChange={(e) =>
                                  toggleBannerType(
                                    block.id,
                                    t,
                                    e.target.checked,
                                  )
                                }
                              >
                                {t}
                              </Checkbox>
                              <Flex alignItems="center" gap={2}>
                                <Text
                                  fontSize="12px"
                                  color="var(--color-label-employee)"
                                >
                                  Order:
                                </Text>
                                <NumberInput
                                  isDisabled={!block.banners[t].checked}
                                  min={1}
                                  value={block.banners[t].order}
                                  onChange={(_, v) =>
                                    changeBannerOrder(block.id, t, v)
                                  }
                                  w="90px"
                                  size="sm"
                                >
                                  <NumberInputField />
                                </NumberInput>
                              </Flex>
                            </Flex>
                          ))}
                        </Grid>
                      </Box>
                    ))}

                    <Flex justifyContent={"end"} alignItems={"center"}>
                      <Button
                        w={"140px"}
                        h={"44px"}
                        lineHeight={"18px"}
                        fontSize={"15px"}
                        fontWeight={600}
                        color={"var(--color-main)"}
                        bg={"var(--linear-gradient-employee)"}
                        onClick={saveBanners}
                        _hover={{ filter: "brightness(90%)" }}
                      >
                        Lưu banner
                      </Button>
                    </Flex>
                  </Flex>
                </Flex>

                {/*  */}
              </Flex>
            </Flex>
          </Box>
          <Flex
            flex={1}
            pr={"24px"}
            alignItems={"center"}
            gap={"16px"}
            justifyContent={"flex-end"}
            position={"sticky"}
            bottom={"24px"}
            right={"24px"}
            left={"50%"}
          >
            {isEdit ? (
              <>
                <Button
                  w={"112px"}
                  h={"44px"}
                  lineHeight={"18px"}
                  fontSize={"15px"}
                  fontWeight={600}
                  color={"var(--color-option-employee-hover)"}
                  border={"1px solid var(--color-option-employee-hover)"}
                  bg={"var(--color-main)"}
                  onClick={onClose}
                  _hover={{
                    filter: "brightness(90%)",
                  }}
                >
                  Hủy
                </Button>
                <Button
                  type="submit"
                  w={"112px"}
                  h={"44px"}
                  lineHeight={"18px"}
                  fontSize={"15px"}
                  fontWeight={600}
                  color={"var(--color-main)"}
                  bg={"var(--linear-gradient-employee)"}
                  _hover={{
                    filter: "brightness(90%)",
                  }}
                >
                  Lưu
                </Button>
              </>
            ) : (
              <Button
                type="submit"
                padding={"13px 20px"}
                lineHeight={"18px"}
                fontSize={"15px"}
                fontWeight={600}
                h={"44px"}
                color={"var(--color-main)"}
                bg={"var(--linear-gradient-employee)"}
                _hover={{
                  filter: "brightness(90%)",
                }}
              >
                Tạo dự án
              </Button>
            )}
          </Flex>
        </form>
        <DeleteDialog
          isOpen={isOpenDelete}
          onClose={onCloseDelete}
          title="Xóa file"
          description={
            <Flex display={"inline"}>
              "Bạn có chắc chắn muốn xóa file{" "}
              <Text fontWeight={"600"} display={"inline"}>
                {nameDelete}
              </Text>{" "}
              này không?"
            </Flex>
          }
          action={() => onDeleteDataFile(deteleFileId)}
        />
        <DeleteDialog
          isOpen={isOpenDeleteImage}
          onClose={onCloseDeleteImage}
          title="Xóa ảnh"
          description={
            <Flex display={"inline"}>
              "Bạn có chắc chắn muốn xóa ảnh{" "}
              <Text fontWeight={"600"} display={"inline"}>
                {nameImageDelete}
              </Text>{" "}
              này không?"
            </Flex>
          }
          action={() => onDeleteImageOther(deteleImageOtherId)}
        />
      </ModalContent>
    </Modal>
  );
};

export default PopupProjectManagementAdd;
